import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Role } from 'my-lib-sanfelici';
import { RolesService } from 'my-lib-sanfelici';




@Component({
  selector: 'app-roles-list',
  templateUrl: './roles-list.component.html',
  styleUrls: ['./roles-list.component.css']
})
export class RolesListComponent implements OnInit {
    roles: Observable<Role[]>;

  constructor(private roleservice:RolesService) { }

  ngOnInit() {
    this.roles = this.roleservice.list();
  }

}
